import { render, staticRenderFns } from "./Measures.vue?vue&type=template&id=5c2e33fa&"
import script from "./Measures.vue?vue&type=script&lang=js&"
export * from "./Measures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports